// Two theater seats side by side — the "Together" nav icon.
// Phosphor has no theater-seat glyph, so this is hand-drawn to sit beside
// Phosphor icons: same API (size, weight, className) and the same line
// weights, so it matches House / Compass / ProjectorScreen / Books / UsersThree.
const STROKE = { thin: 1, light: 1.25, regular: 1.5, bold: 2 };

export function TogetherSeatsIcon({ size = 24, weight = "light", className = "", ...rest }) {
  const sw = STROKE[weight] ?? STROKE.light;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={sw}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      {/* seat backs */}
      <rect x="3.75" y="4.5" width="6.5" height="8" rx="2.25" />
      <rect x="13.75" y="4.5" width="6.5" height="8" rx="2.25" />
      {/* cushions */}
      <rect x="3" y="12.5" width="8" height="3" rx="1.25" />
      <rect x="13" y="12.5" width="8" height="3" rx="1.25" />
      {/* armrests (outer + shared middle) */}
      <path d="M2 10.5v8M12 10.5v8M22 10.5v8" />
      <path d="M1.25 10.5h1.5M11.25 10.5h1.5M21.25 10.5h1.5" />
      {/* floor rail */}
      <path d="M2 18.5h20" />
    </svg>
  );
}
